import { DeviceTypes } from '../../../constants/DeviceModels';
import { OUTPUT_TTL } from '../../../constants/Pac';
import type RootStore from '../../root-store';

/**
 * Dust collector controller
 *
 * @param rootStore
 * @param turnOn
 */
export const dustCollectorSwitch = (
  rootStore: RootStore,
  turnOn: boolean = true,
): void => {
  const { batchStore, devicesStore } = rootStore;
  const dustCollector = devicesStore.devices.find(v => v.deviceTypeName === DeviceTypes.DustCollector);

  if (dustCollector?.switchPNo) {

    if (batchStore.isOutputOn(dustCollector.switchPNo) === turnOn) {
      return;
    }

    batchStore.setOutput(dustCollector.switchPNo, turnOn ? OUTPUT_TTL : '0');
  }
};
